module.exports = __webpack_public_path__ + "img/1010.c9c6c2fe.jpg";